export default "__VITE_PUBLIC_ASSET__18dd8e3f__"